import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BuildingTextFilter } from '../buildingTextFilter/BuildingTextFilter';

require('./BuildingsFilter.css');

export type Props = {
    textFilter: string;
    onChange(
        text: string,
    ): void;
};

export const BuildingFilter = ({
    textFilter,
    onChange,
}: Props) => {
    const { t } = useTranslation();

    const handleChangeText = useCallback((text: string) => {
        onChange(text);
    }, [ onChange ]);

    const handleClickReset = useCallback(() => {
        onChange('');
    }, [ onChange ]);

    const canReset = textFilter.length > 0;

    return (
        <div id="building-list-filter">
            <h3>
                { t('BUILDINGS.FILTER') }
            </h3>
            <BuildingTextFilter
                text={ textFilter }
                onChange={ handleChangeText }
            />
            { /* TODO?
            <BuildingCountryFilter
                country={ localCountry }
                onChange={ setLocalCountry }
            />
            */ }
            <div>
                <button
                    type="button"
                    className="ui tiny button"
                    disabled={ !canReset }
                    onClick={ handleClickReset }
                >
                    { t('COMMAND.RESET') }
                </button>
            </div>
        </div>
    );
};
